import { PopupEvent } from 'components';
import { AnimatePresence } from 'framer-motion';
import { useOutsideClick } from 'hooks';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const PopupEventWrapper = ({
  children = null,
  isOpen = false,
  popupMessageText,
  popupButtons = null,
  buttonContainerStyles = {},
  popupStyles = {},
  innerComponent = null,
  onPopupClose = () => {},
  darkBackground,
  extraMessageStyle = {},
  selectionOptions = null,
  defaultSelectionValue = undefined,
  cancelButtonText = undefined,
  confirmButtonText = undefined,
  hideCloseButton = undefined,
  enhancedLayout = false,
  stackFooterActions = false,
}) => {
  const [open, setOpen] = useState(isOpen);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const toggleOpen = () => {
    setOpen((currentOpen) => !currentOpen);
  };

  const closePopup = useCallback(() => {
    setOpen(false);
    onPopupClose();
  }, [onPopupClose]);

  const wrapperRef = useRef();

  useOutsideClick(wrapperRef, closePopup);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        closePopup();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [closePopup, open]);

  return (
    <>
      <div onClick={toggleOpen}>{children}</div>

      {createPortal(
        <AnimatePresence>
          {open && (
            <PopupEvent
              wrapperRef={wrapperRef}
              closePopup={closePopup}
              popupMessageText={popupMessageText}
              popupButtons={popupButtons}
              buttonContainerStyles={buttonContainerStyles}
              popupStyles={popupStyles}
              innerComponent={innerComponent}
              extraMessageStyle={extraMessageStyle}
              darkBackground={darkBackground}
              selectionOptions={selectionOptions}
              defaultSelectionValue={defaultSelectionValue}
              cancelButtonText={cancelButtonText}
              confirmButtonText={confirmButtonText}
              hideCloseButton={hideCloseButton}
              enhancedLayout={enhancedLayout}
              stackFooterActions={stackFooterActions}
            />
          )}
        </AnimatePresence>,
        document.getElementById('modal'),
      )}
    </>
  );
};

export default PopupEventWrapper;
